import type { Metadata } from "next";
import { ServiceJsonLd, BreadcrumbJsonLd } from "@/components/JsonLd";

export const metadata: Metadata = {
  title: "Web Development Services — Next.js, React & Full-Stack",
  description:
    "Custom web development with Next.js, React, TypeScript, and Tailwind CSS. E-commerce, SaaS platforms, business websites. 20+ projects delivered. From $2,500.",
  openGraph: {
    title: "Web Development Services — Dev Cubix",
    description:
      "Next.js, React, TypeScript, Tailwind CSS. E-commerce, SaaS, business websites. 20+ projects delivered.",
    url: "https://devcubix.com/services/webdev",
  },
  alternates: {
    canonical: "https://devcubix.com/services/webdev",
  },
};

export default function WebDevServiceLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <ServiceJsonLd
        name="Web Development"
        description="Custom web development with Next.js, React, TypeScript, and Tailwind CSS. E-commerce, SaaS platforms, and business websites."
        url="https://devcubix.com/services/webdev"
        price="2500"
      />
      <BreadcrumbJsonLd
        items={[
          { name: "Home", url: "https://devcubix.com" },
          { name: "Services", url: "https://devcubix.com/services" },
          { name: "Web Development", url: "https://devcubix.com/services/webdev" },
        ]}
      />
      {children}
    </>
  );
}
